import { Component, OnInit } from '@angular/core';
import { AdminService } from '@app/services/admin/admin.service';
import { PermissionsexporterService } from '@app/services/admin/permissionsexporter.service';
import { SnackbarService } from '@app/services/shared/snackbar.service';
import { SelectItem } from 'primeng/api';
import { forkJoin } from 'rxjs';
@Component({
  selector: 'app-admin-system-access',
  templateUrl: './admin-system-access.component.html',
  styleUrls: ['./admin-system-access.component.css']
})
export class AdminSystemAccessComponent implements OnInit {
  defaultPermissions: any[] = [];
  currentRole;
  selectedPermissions = [];
  selectedrole;
  roles: SelectItem[] = [];

  constructor(private adminService: AdminService, private snackBarService: SnackbarService, private PermissionsexporterService: PermissionsexporterService) { }

  ngOnInit() {
    this.adminService.GetPermissionLevels().subscribe(permissionData => {

      const permissionLevelPermissionArray = [];

      permissionData.forEach(permissionLevel => {
        const toPermissionLevel = ({
          label: permissionLevel.description,
          value: permissionLevel.id
        });
        permissionLevelPermissionArray.push((toPermissionLevel) as any);
      });
      this.roles = permissionLevelPermissionArray;
    });
  }

  viewAccess(evt) {
    this.defaultPermissions = [];
    this.currentRole = {
      Description: evt.value.label,
      Id: evt.value.value
    };
    this.adminService.GetPossiblePermissions(this.currentRole).subscribe(data => {
      // this.adminService.GetActivePermissions(this.currentRole).subscribe(data => {
      this.selectedPermissions = data;

     // this.selectedPermissions.sort((a, b) => parseFloat(a.category) - parseFloat(b.category));
    });
  }

exportPermissionsToExcel(roles: any[]) {

  
  this.PermissionsexporterService.exportPermissionsToExcel(roles);
}

loadAllRolesPermissions() {
  const requests = this.roles.map(role => {
    const roleRequest = {
      Id: role.value,
      Description: role.label
    };

    return this.adminService.GetPossiblePermissions(roleRequest);
  });

  forkJoin(requests).subscribe(allPermissions => {
    // allPermissions[index] hör ihop med roles[index]
    allPermissions.forEach((permissions, index) => {
     // this.roles[index].permissions = permissions;
    });

    // Nu har ALLA roller sina permissions
    this.exportPermissionsToExcel(this.roles);
  });
}

  updatePermission(evt) {

    if (evt.checked) {
      this.adminService.AddPermission(evt.source.value.permissionLevelId, evt.source.value.permissionId).subscribe(response => {

        if (response) {
          this.snackBarService.openSnackBar(evt.source.value.description + ' har lagts till.', null);
        }
      });
    } else {
      this.adminService.RemovePermission(evt.source.value.permissionLevelId, evt.source.value.permissionId).subscribe(response => {

        if (response) {
          this.snackBarService.openSnackBar(evt.source.value.description + ' har tagits bort.', null);
        }
      })
    }
  }

}
